const getTooltipTitle = (type, t) => {
  return (
    {
      lightIntensity: t("icon.lightintensity"),
      airTemperature: t("icon.airtemperature"),
      relativeHumidity: t("icon.relativehumidity"),
      waterLevel: t("icon.waterlevel"),
      soilwater: t("icon.soilmoisture"),
      pm10: "PM10",
      "pm2.5": "PM2.5",
      outsideVoltage: t("icon.voltage"),
      battery: t("icon.battery"),
      tds: t("icon.tds"),
      temp: t("icon.temp"),
    }[type] ?? <>{type}</>
  );
};

export default getTooltipTitle;
